module.exports = __webpack_public_path__ + "img/Banco icon.13349253.svg";